"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { motion } from "framer-motion";
import { MapPin, CircleCheck as CheckCircle2, Phone, Mail, ArrowRight, ShieldCheck, UserCheck, Star } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Link } from "@/components/common/Link";
export default function Localhero() {
  const trustSignals = ["Direct Access to Yassine Essaadi", "Tailored Wakefield & West Yorkshire Strategy", "Google Map Pack & Local Lead Growth", "Transparent Monthly Reporting"];
  return <section id="localherowakefield" data-nav="dark" className="relative w-full overflow-hidden bg-primary text-primary-foreground py-16 md:py-24 lg:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 -left-24 size-96 rounded-full bg-accent/20 blur-3xl" />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-32 -right-20 size-96 rounded-full bg-accent/15 blur-3xl" />

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center lg:gap-8">
          
          {}
          <motion.div className="lg:col-span-7 flex flex-col items-start" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: "easeOut"
        }}>
            {}
            <div className="mb-6 flex flex-wrap items-center gap-2">
              <Badge variant="secondary" className="bg-accent/20 text-accent-foreground border-accent/30 px-3 py-1 text-sm font-medium backdrop-blur-sm">
                <MapPin className="mr-1.5 size-4 text-accent" />
                Wakefield &amp; West Yorkshire SEO Specialist
              </Badge>
              <Badge variant="outline" className="border-primary-foreground/30 text-primary-foreground text-xs">
                Independent Consultant
              </Badge>
            </div>

            {}
            <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-primary-foreground leading-[1.15]">
              Local SEO Consultant in Wakefield
            </h1>

            {}
            <p className="font-sans mt-6 text-lg sm:text-xl text-primary-foreground/90 max-w-2xl font-light leading-relaxed">
              I help Wakefield businesses dominate local Google search results, capture top Map Pack positions, and win high-converting local clients. You work directly with me—no junior account managers, no generic agency templates.
            </p>

            {}
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3.5 w-full max-w-xl">
              {trustSignals.map((signal, index) => <div key={index} data-index={index} className="flex items-center gap-2.5 text-sm sm:text-base text-primary-foreground/95">
                  <CheckCircle2 className="size-5 shrink-0 text-accent" />
                  <span>{signal}</span>
                </div>)}
            </div>

            {}
            <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 shadow-lg text-base font-semibold px-8 h-12">
                <Link to="/ContactPage" className="inline-flex items-center justify-center gap-2">
                  Book a Free Consultation
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="border-primary-foreground/30 bg-primary/40 text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground text-base h-12">
                <Link to="/CaseStudiesPage">
                  Explore Case Studies
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-10 pt-6 border-t border-primary-foreground/15 flex flex-wrap items-center gap-6 text-xs sm:text-sm text-primary-foreground/80">
              <a href="mailto:contact@ye-consultancy.com" className="inline-flex items-center gap-2 hover:text-accent transition-colors">
                <Mail className="size-4 text-accent" />
                <span>contact@ye-consultancy.com</span>
              </a>
              <a href="tel:+447490984430" className="inline-flex items-center gap-2 hover:text-accent transition-colors">
                <Phone className="size-4 text-accent" />
                <span>+44 7490984430</span>
              </a>
            </div>
          </motion.div>

          {}
          <motion.div className="lg:col-span-5" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: "easeOut"
        }}>
            <div className="relative mx-auto max-w-md lg:max-w-none">
              
              {}
              <div className="relative overflow-hidden rounded-2xl bg-card text-card-foreground p-6 sm:p-8 shadow-2xl border border-border">
                
                {}
                <div className="flex items-center gap-4 pb-6 border-b border-border">
                  <SafeHydrate><Avatar className="size-20 border-2 border-primary shadow-md shrink-0">
                    <AvatarImage src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/yassine_essaadi_wakefield_seo.webp" alt="Yassine Essaadi - Freelance SEO Consultant" />
                    <AvatarFallback className="bg-primary text-primary-foreground font-serif text-xl font-bold">
                      YE
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div>
                    <h2 className="font-serif text-xl font-bold text-card-foreground">
                      Yassine Essaadi
                    </h2>
                    <p className="text-sm text-muted-foreground font-medium">
                      Lead SEO Strategy Consultant
                    </p>
                    <div className="mt-1 inline-flex items-center gap-1 text-xs text-accent font-semibold">
                      <UserCheck className="size-3.5" />
                      <span>100% Direct Collaboration</span>
                    </div>
                  </div>
                </div>

                {}
                <div className="py-6 space-y-4">
                  <div className="rounded-xl bg-muted p-4 border border-border/50">
                    <div className="flex items-start gap-3">
                      <ShieldCheck className="size-5 text-primary shrink-0 mt-0.5" />
                      <div>
                        <h3 className="font-serif text-sm font-semibold text-card-foreground">
                          Wakefield SEO Focus
                        </h3>
                        <p className="text-xs text-muted-foreground mt-1">
                          Tailored local citations, Google Business Profile optimization, and geotargeted content for maximum regional impact.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="rounded-xl bg-muted p-4 border border-border/50">
                    <div className="flex items-start gap-3">
                      <Star className="size-5 text-accent shrink-0 mt-0.5" />
                      <div>
                        <h4 className="font-serif text-sm font-semibold text-card-foreground">
                          No Long Lock-in Contracts
                        </h4>
                        <p className="text-xs text-muted-foreground mt-1">
                          Honest deliverables, transparent monthly reporting, and measurable commercial growth for local businesses.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {}
                <div className="pt-2 text-center">
                  <Button asChild variant="default" size="default" className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-medium">
                    <Link to="/AboutMePage">
                      Read About My SEO Approach
                    </Link>
                  </Button>
                </div>

              </div>

              {}
              <div className="hidden sm:flex absolute -bottom-5 -right-5 bg-accent text-accent-foreground rounded-xl px-4 py-3 shadow-xl border border-accent/20 items-center gap-3 max-w-[220px]">
                <MapPin className="size-6 shrink-0" />
                <p className="text-xs font-semibold leading-tight">
                  Serving Wakefield, Leeds &amp; West Yorkshire
                </p>
              </div>

            </div>
          </motion.div>

        </div>
      </div>
    </section>;
}